module.exports = __webpack_public_path__ + "img/img_17.7eb8e10a.jpg";